let configs = {
  lang: 'en'
};
export const init = () => {
  const savedConfigs = global.localStorage.getItem('configs');
  if (savedConfigs) {
    configs = JSON.parse(savedConfigs);
  } else {
    global.localStorage.setItem('configs', JSON.stringify(configs));
  }
};
export const get = key => configs[key];
export const set = (key, value) => {
  configs[key] = value;
  global.localStorage.setItem('configs', JSON.stringify(configs));
};